export async function importDynamicData<TData = any>(path: string): Promise<TData> {
  const filePath = path.charAt(0) === '/' ? path.substring(1) : path;
  const { default: data } = await import(`../data/${filePath}`);

  return data;
}
